import React from 'react';
import styled from 'styled-components';
import Swiper from 'swiper/dist/js/swiper';
import 'swiper/dist/css/swiper.min.css';

import { Flex } from './static/style';
import { LevelData, KETLevelData } from './static/json/level-data'

export default class LessonLevels extends React.Component {
    componentDidMount() {
        const that = this;
        const { clickLevelCardHandler, special } = that.props;
        const specialLevel = [2004, 2005, 2006];

        new Swiper('.swiper-container', {
            // slidesPerView: 2,
            slidesPerView: 'auto',
            initialSlide: this.props.active > -1 ? this.props.active : 0, //默认选中
            spaceBetween: 30,
            centeredSlides: true,
            slideToClickedSlide: true,
            mousewheel: true,
            on: { //slideChangeTransitionEnd
                click: function () {
                    //改变level 
                    if (clickLevelCardHandler && typeof clickLevelCardHandler === 'function') {
                        clickLevelCardHandler(special ? specialLevel[this.activeIndex] : parseInt(this.activeIndex, 10));
                    } else {
                        console.log('click callback not exist');
                    }
                },
                touchStart: function () {
                    this.touches.diff = 0;
                },
                touchEnd: function () {
                    if (this.touches.diff === 0) {
                        console.log('模拟单击')
                        if (clickLevelCardHandler && typeof clickLevelCardHandler === 'function') {
                            clickLevelCardHandler(special ? specialLevel[this.activeIndex] : parseInt(this.activeIndex, 10));
                        } else {
                            console.log('click callback not exist');
                        }
                    }
                }
            }
        })
    }

    render() {
        const { data, special } = this.props;

        return (
            <React.Fragment>
                {special ?
                    <Levels>
                        <Title>真题选择</Title>
                        <KETDesc>目标学员<span>具备KET或欲全面提升英语能力的初中水平学生</span></KETDesc>
                        <SwiperBox>
                            <SwiperContainer className='swiper-container' ref='lun'>
                                <div className='swiper-wrapper'>
                                    {KETLevelData && Array.isArray(KETLevelData) && KETLevelData.map((item, index) =>
                                        <SwiperSlide className='swiper-slide' key={index} active={index === this.props.active ? true : false}>
                                            <LevelBox>
                                                <KETLevelNumber bgColor={item.title_background_color}>{item.level}
                                                    <span>{item.range}</span>
                                                </KETLevelNumber>
                                                <KETTitle>学习内容</KETTitle>
                                                <KETTarget>
                                                    {item.target.map((value, index) =>
                                                        <li key={index} dangerouslySetInnerHTML={{ __html: value }} />
                                                    )}
                                                </KETTarget>
                                                <KETTitle>教学目标</KETTitle>
                                                <TargetDetail>
                                                    {item.targetDetail.map((value, index) =>
                                                        <KETTargetDetailItem key={index}>{value}</KETTargetDetailItem>
                                                    )}
                                                </TargetDetail>
                                            </LevelBox>
                                        </SwiperSlide>
                                    )}
                                </div>
                            </SwiperContainer>
                        </SwiperBox>
                    </Levels>
                    :
                    <Levels>
                        <Title>选择学习级别</Title>
                        <SwiperBox>
                            <SwiperContainer className='swiper-container' ref='lun'>
                                <div className='swiper-wrapper'>
                                    {data && Array.isArray(data) && data.map((item, index) =>
                                        <SwiperSlide className='swiper-slide' key={index} active={index === this.props.active ? true : false}>
                                            {LevelData[index] &&
                                                <LevelBox>
                                                    <LevelNumber bgColor={LevelData[index].title_background_color}>{LevelData[index].level}</LevelNumber>
                                                    <Range>{LevelData[index].range}</Range>
                                                    <Target>
                                                        {/* {LevelData[index].target.map((value, index) =>
                                                    <div key={index}>{value}</div>
                                                )} */}
                                                        {LevelData[index].target_2.map((value, index) =>
                                                            <TargetItem2 key={index}>
                                                                <TargetNum dangerouslySetInnerHTML={{ __html: value.num }} />
                                                                <TargetContent>{value.content}</TargetContent>
                                                            </TargetItem2>
                                                        )}
                                                    </Target>
                                                    <LevelGrade>
                                                        {new Array(7).fill(1).map((value, levelIndex) =>
                                                            <LevelGradeItem key={levelIndex} index={levelIndex} current={index} />
                                                        )}
                                                    </LevelGrade>
                                                    <TargetDetail>
                                                        {LevelData[index].targetDetail.map((value, index) =>
                                                            <TargetDetailItem key={index}>{value}</TargetDetailItem>
                                                        )}
                                                    </TargetDetail>
                                                </LevelBox>
                                            }
                                        </SwiperSlide>
                                    )}
                                </div>
                            </SwiperContainer>
                        </SwiperBox>
                    </Levels>}
            </React.Fragment>
        );
    }
}

const Levels = styled.div`
    width: 100%;
    height: 100%;
`;

const Title = styled.div`
    position:fixed;
    width: 100%;
    margin: 0.58rem auto;
    color: #fff;
    font-size: 0.38rem;
    text-align: center;
    line-height: 0.53rem;
`;

const SwiperBox = styled(Flex)`
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
`;

const SwiperContainer = styled.div`
    width: 100%;
    height: 7.12rem;
    overflow: unset !important;
`;

const SwiperSlide = styled.div`
    position: relative;
    max-width: 5.12rem;
    transition: 300ms;
    transform: scale(0.9);
    -webkit-transform: scale(0.9);
    cursor: pointer;

    &.swiper-slide-active {
        transform: scale(1);
        -webkit-transform: scale(1);
    }

    ${props => props.active ? `
        &::after {
            position: absolute;
            content: '';
            display: block;
            top: -0.67rem;
            left: 0.58rem;
            width: 0.83rem;
            height: 0.67rem;
            background: url(${require('./static/img/level-current.png')}) no-repeat center;
            background-size: contain;
        }
    ` : ''}
`;

const LevelBox = styled.div`
    padding: 0.46rem 0.32rem 0;
    width: 5.12rem;
    height: 6.72rem;
    background: #fff;
    border-radius: 0.64rem;
`;

const LevelNumber = styled.div`
    position: absolute;
    top: -0.34rem;
    left: 50%;
    transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    width: 2.08rem;
    height: 0.68rem;
    border-radius: 0.4rem;
    border: 0.05rem solid #fff;
    background: ${props => props.bgColor ? props.bgColor : ''};
    color: #fff;
    font-size: 0.36rem;
    text-align: center;
    line-height: 0.58rem;
`;

const Range = styled.div`
    margin: 0 auto 0.16rem;
    text-align: center;
    color: #5D5D5D;
    font-size: 0.23rem;
`;

const Target = styled(Flex)`
    justify-content: row;
    flex-wrap: wrap;
    height: 1.33rem;
    width: 100%;
    padding: 0.24rem 0.1rem 0.24rem 0.32rem;
    color: #008BFF;
    font-size: 0.21rem;
    line-height: 0.29rem;
    background: #DFF0FF;
    border-radius: 0.16rem;
    justify-content: space-around;
    align-items: center;

    /* >div:nth-child(odd)  {
        width: 50%;
    }
    >div:nth-child(even)  {
        width: 50%;
    } */
`;

const TargetItem2 = styled.div`
    text-align: center;
`;

const TargetNum = styled.div`
    font-size: 0.38rem;
    >span {
        font-size: 0.2rem;
    }
`;

const TargetContent = styled.div`
    font-size: 0.2rem;
`;

const LevelGrade = styled(Flex)`
    position: relative;
    margin: 0.32rem 0;
    width: 100%;
    height: 1.41rem;
    justify-content: space-around;
    align-items: flex-end;
`;

const LevelGradeItem = styled.div`
    position: relative;
    width: 0.58rem;
    background: #DFF0FF;
    border-radius: 0.29rem;

    &:nth-child(1) {
        height: 0.51rem;
    }
    &:nth-child(2) {
        height: 0.70rem;
    }
    &:nth-child(3) {
        height: 0.86rem;
    }
    &:nth-child(4) {
        height: 1.06rem;
    }
    &:nth-child(5) {
        height: 1.22rem;
    }
    &:nth-child(6) {
        height: 1.41rem;
    }
    &:nth-child(7) {
        height: 1.57rem;
    }

    ${props => props.index === props.current ? `
        background: #813CFC;

        &::after {
            position: absolute;
            content: 'L${props.index ? props.index : 'K'}';
            display: block;
            top: 50%;
            transform: translateY(-50%);
            -webkit-transform: translateY(-50%);
            width: 100%;
            color: #fff;
            text-align: center;
            font-size: 0.21rem;
        }
    ` : ''}
`;

const TargetDetail = styled.div`
    padding-left: 0.3rem;
`;

const TargetDetailItem = styled.div`
    position: relative;
    color: #606060;
    font-size: 0.19rem;
    line-height: 0.26rem;
    margin-bottom: 0.08rem;

    &::after {
        position: absolute;
        content: '';
        display: block;
        top: 0.05rem;
        left: -0.3rem;
        width: 0.22rem;
        height: 0.17rem;
        background: url(${require('./static/img/icon-green-right.png')}) no-repeat center;
        background-size: contain;
    }
`;

const KETTargetDetailItem = styled.div`
    position: relative;
    color: #606060;
    font-size: 0.19rem;
    line-height: 0.35rem;
    padding-left: 0.1rem;
    margin-bottom: 0.28rem;

    &::after {
        position: absolute;
        content: '';
        display: block;
        top: 0.05rem;
        left: -0.3rem;
        width: 0.28rem;
        height: 0.28rem;
        background: url('https://webres.putaoabc.com/course/images/ai_course/icon_green_right2.png') no-repeat center;
        background-size: contain;
    }
`;

const KETTitle = styled.div`
    margin: 0.4rem 0 0.2rem;
    font-size: 0.25rem;
    color: #B5B5B5;
    &:before {
        content: ' ';
        width: 0.1rem;
        height: 0.3rem;
        display: inline-block;
        margin-right: 0.1rem;
        border-radius: 0.1rem;
        vertical-align: middle;
        background: #ADC1FA;
    }
`

const KETDesc = styled.div`
    text-align: center;
    position: fixed;
    width: 100%;
    margin: 1.58rem auto;
    color: #fff;
    font-size: 0.28rem;
    span {
        opacity: 0.8;
        padding-left: 0.3rem;
    }
`

const KETTarget = styled.ul`
    width: 100%;
    line-height: 0.4rem;
    padding-left: 0.24rem;
    font-size: 0.21rem;
    line-height: 0.45rem;
    color: #606060;
    span {
        color: #5E86F7;
    }
`

const KETLevelNumber = styled.div`
    position: absolute;
    top: -0.48rem;
    left: 50%;
    transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    width: 3rem;
    height: 1.2rem;
    padding-top: 0.1rem;
    border-radius: 0.4rem;
    border: 0.06rem solid #fff;
    background: ${props => props.bgColor ? props.bgColor : ''};
    color: #fff;
    font-size: 0.3rem;
    text-align: center;
    line-height: 0.4rem;
    span {
        display: block;
        font-size: 0.36rem;
    }
`;


// WEBPACK FOOTER //
// ./src/lib/components/LessonPath/lesson-levels.js